/**
 * KontekstRoute
 * Superadmin uten valgt organisasjon sendes til /superadmin.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const KontekstRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { hasRole, orgKontekst } = useAuth();
  if (hasRole('superadmin') && !orgKontekst) {
    return <Navigate to="/superadmin" replace />;
  }
  return <>{children}</>;
};

export default KontekstRoute;
